<template>
  <div
    v-if="
      $auth.loggedIn ||
        (currentFilters && currentFilters.length > 0)
    "
    class="category-filter-container pure-form"
    :class="{'collapsed-mobile': isCollapsedMobile && showResetOnCcrs, 'category-filter-container--categories-page': showOnCategoriesPage}"
  >
    <div
      class="category-filter-header-wrapper"
      :class="{'category-filter-header-wrapper--ccrs': showResetOnCcrs, 'on-mobile': isMobile}"
    >
      <div
        class="category-filter-header-clickable"
        :class="{'clickable': showResetOnCcrs}"
        @click="showResetOnCcrs ? isCollapsedMobile = !isCollapsedMobile : null"
      >
        <h2
          v-if="!showResetOnCcrs"
          class="category-filter-header"
        >
          {{ $tv('items', 'cart') }}
        </h2>
        <h3 class="category-filter-subheader">
          {{ $tv('filters', 'categories') }}
        </h3>
        <NavigationExpandMore
          v-if="showResetOnCcrs"
          class="expand-more-icon expand-more-icon--mobile"
          :class="isCollapsedMobile ? '' : 'open-icon'"
        />
      </div>
      <ToggleSwitchSquare
        class="category-filter__unit-switch"
        v-if="showInchToggle && (showResetOnCcrs || !isCollapsedMobile) && !isMobile"
        :is-checked="showInchValues"
        :label-right="$tv('metricInchToggleRightText','product')"
        :label-left="$tv('metricInchToggleLeftText','product')"
        @change-value="toggleShowInchValues"
      />
    </div>
    <div
      :class="[categoryType === 'design' ? '' : 'no-image-content', 'category-filter-container__filters', filterOpened ? '' : 'category-filter-container__filters--closed']"
      v-if="facets"
      v-show="!showResetOnCcrs || !isCollapsedMobile"
    >
      <div
        class="category-filter-container__filters__collapsible-header"
        v-show="isMobile && !inPopup"
      >
        <div
          class="header-clickable"
          @click="toggleFilter"
          :class="{'opened': filterOpened}"
        >
          <h3
            class="category-filter-subheader"
          >
            {{ $tv('filters', 'categories') }}
          </h3>
          <NavigationExpandMore
            class="expand-more-icon"
          />
        </div>
        <div
          class="category-filter__unit-switch--mobile"
        >
          <ToggleSwitchSquare
            :is-checked="showInchValues"
            :label-right="$tv('metricInchToggleRightText','product')"
            :label-left="$tv('metricInchToggleLeftText','product')"
            @change-value="toggleShowInchValues"
          />
        </div>
      </div>
      <div
        class="category-filter-container__filters__wrapper"
        :class="{'category-filter-container__filters__wrapper--opened': filterOpened || inPopup}"
      >
        <div
          class="category-filter-container__filters__wrapper__content"
          :class="{'show-core-filters-only': !showAllFilters}"
        >
          <div
            v-for="(filter, index) in currentFilters"
            :key="filter.id"
            :class="[
              filter.isCoreFilter ? 'coreFilter' : 'noCoreFilter',
              'category-filter-container__filters__wrapper__content__filter',
            ]"
          >
            <template v-if="isTypeDropdown(filter.type)">
              <DropDown
                :filter-values="getFilterValuesFromFacets(filter)"
                :label="filter.label"
                :title="filter.title"
                :selected-values="filter.values"
                :identifier="index"
                :disabled="isFilterDisabled(filter) || getFilterValuesFromFacets(filter).length === 0"
                :has-info-icon="filter.hasInfoIcon"
                :is-sorted="true"
                :popup-class-name="popupClassName"
                @input="categoryChange($event, filter); $emit('filterChanged')"
                v-show="filter.isCoreFilter || showAllFilters || (showResetOnCcrs && filter.isFilteredBy)"
              />
            </template>
            <template
              v-if="(isTypeString(filter.type) || isTypeMultiInteger(filter.type) || isTypeMultiString(filter.type))"
            >
              <MultiSelect
                :filter-values="getFilterValuesFromFacets(filter)"
                :label="filter.label"
                :title="filter.title"
                :selected-values="filter.values"
                :identifier="index"
                :disabled="filter.isDisabled || getFilterValuesFromFacets(filter).length === 0"
                :has-info-icon="filter.hasInfoIcon"
                :is-sorted="true"
                :sort-descending="filter.shortName === 'DASH_NR'"
                :popup-class-name="popupClassName"
                @input="filter.values = $event; $emit('filterChanged')"
                v-show="filter.isCoreFilter || showAllFilters || (showResetOnCcrs && filter.isFilteredBy)"
              />
            </template>
            <template v-if="isTypeNumber(filter.type) || isTypeMultiDouble(filter.type)">
              <Range
                :filter-values="getFilterValuesFromFacets(filter)"
                :format="filter.type"
                :label="filter.label"
                :title="filter.title"
                :selected-values="filter.values"
                :identifier="index"
                :disabled="filter.isDisabled"
                :localized-measure="filter.localizedUnitOfMeasure"
                @focusin="setActiveFilter(filter.shortName)"
                @focusout="(e) => { if (!e.currentTarget.contains(e.relatedTarget)) clearActiveFilter() }"
                @input-value="filter.values = $event; setActiveFilter(filter.shortName); $emit('filterChanged')"
                v-show="filter.isCoreFilter || showAllFilters || (showResetOnCcrs && filter.isFilteredBy)"
              />
            </template>
            <template v-if="isTypeMinMaxNumber(filter.type)">
              <AttributeFilterNumber
                :format="filter.type"
                :label="filter.label"
                :title="filter.title"
                :identifier="index"
                :selected-values="filter.values"
                @focusin="setActiveFilter(filter.shortName)"
                @focusout="(e) => { if (!e.currentTarget.contains(e.relatedTarget)) clearActiveFilter() }"
                @input-value="filter.values = $event; setActiveFilter(filter.shortName); $emit('filterChanged')"
                v-show="filter.isCoreFilter || showAllFilters || (showResetOnCcrs && filter.isFilteredBy)"
              />
            </template>
            <template v-if="isTypeBool(filter.type)">
              <div class="toggleSwitch filter-item-wrapper">
                <ToggleSwitch
                  :is-checked="filter.values"
                  :label="filter.label"
                  @change-value="(value) => { filter.values = value; $emit('filterChanged') }"
                />
              </div>
            </template>
          </div>
        </div>
        <div
          :class="{
            'no-core-filters':
              !currentFilters ||
              currentFilters.filter((f) => !f.isCoreFilter).length <= 0,
          }"
          class="category-filter-container__button__wrapper"
          v-show="!showResetOnCcrs || !isCollapsedMobile"
        >
          <kbutton
            v-if="!showResetOnCcrs"
            class="button__secondary--showMore"
            :theme-color="'base'"
            @click="displayAllFilter"
          >
            <span class="subline">
              {{ $tv(buttonText) }}
            </span>
            <NavigationExpandMore
              class="expand-more-icon"
              :class="buttonClass"
            />
          </kbutton>
          <kbutton
            v-if="showResetOnCcrs && currentFilters && currentFilters.length > 0"
            :theme-color="'base'"
            :disabled="disableReset"
            ref="resetFilters"
            @click="$emit('resetFilters')"
          >
            <span class="subline">{{ $tv('ccrsResetButton', 'ccrs') }}</span>
          </kbutton>
          <kbutton
            v-if="currentFilters && currentFilters.length > 0"
            :theme-color="showResetOnCcrs ? 'base' : 'primary'"
            :disabled="showResetOnCcrs && disableButtons"
            class="button button__primary button--apply-filters"
            @click="applyFilterHandler"
          >
            <span class="subline">
              {{ $tv("apply-filter", "categories") }}
            </span>
          </kbutton>
        </div>
      </div>
      <div
        class="category-filter-container__filters__content__image"
        :class="{'category-filter-container__filters__content__image--opened': filterOpened}"
      >
        <slot />
      </div>
      <component
        v-if="isMobile"
        :is="labelContainerRenderer"
      />
    </div>
    <component
      v-if="!isMobile"
      :is="labelContainerRenderer"
    />
  </div>
</template>

<script>
import {
  ATTRIBUTE_IDENTIFIER_NEW,
  isNoAttributeFilter,
  DEFAULT_VALUES,
  VALUE_TYPES,
  setFilterValues
} from '~/assets/js/filters'
import {sanitizeHtml} from '~/assets/js/utils'
import {NON_ATTRIBUTE_FILTERS, REGION_KEYS} from '~/assets/js/constants'
import {Button} from '@progress/kendo-vue-buttons'
import {useUserStore} from '@/store/user'
import MultiSelect from './AttributeFilterMultiSelect.vue'
import DropDown from './AttributeFilterDropDown.vue'
import Range from './AttributeFilterRange.vue'
import AttributeFilterNumber from './AttributeFilterNumber.vue'
import Labels from './AttributeFilterLabel.vue'
import ToggleSwitch from '~/components/input-components/ToggleSwitch.vue'
import ToggleSwitchSquare from '~/components/input-components/ToggleSwitchSquare.vue'
import NavigationExpandMore from '~/assets/icons/navigation_expand_more.svg?component'
import {storeToRefs} from 'pinia'
import {mapProductAttributeNames} from '~/assets/js/utils/product_attributes_mapping'
import {detectDuplicateFilters, logDuplicatesToSentry} from '~/utils/filterDuplicateDetection'
import {h} from 'vue'

export default {
  name: 'CategoryFilter',
  components: {
    kbutton: Button,
    MultiSelect,
    DropDown,
    Range,
    AttributeFilterNumber,
    Labels,
    ToggleSwitch,
    ToggleSwitchSquare,
    NavigationExpandMore
  },
  props: {
    filters: {
      type: Array || null,
      required: true,
      default() {
        return []
      }
    },
    facets: {
      type: [Object, null],
      required: true,
      default() {
        return null
      }
    },
    productCount: {
      type: Number,
      default() {
        return null
      }
    },
    isMobile: {
      type: Boolean,
      default() {
        return false
      }
    },
    showChips: {
      type: Boolean,
      default() {
        return true
      }
    },
    // When true, show a reset button specific to CCRS page
    showResetOnCcrs: {
      type: Boolean,
      default() {
        return false
      }
    },
    showOnCategoriesPage: {
      type: Boolean,
      default() {
        return false
      }
    },
    disableButtons: {
      type: Boolean,
      default() {
        return false
      }
    },
    disableReset: {
      type: Boolean,
      default() {
        return false
      }
    },
    categoryType: {
      type: String,
      default() {
        return ''
      }
    },
    inPopup: {
      type: Boolean,
      default() {
        return false
      }
    },
    popupClassName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  setup() {
    const {showInchValues, settings} = storeToRefs(useUserStore())
    const {updateSettings} = storeToRefs(useUserStore())
    const i18n = useI18n()
    return {
      showInchValues,
      userSettings: settings,
      updateSettings,
      i18n
    }
  },
  data() {
    return {
      showAllFilters: false,
      buttonText: 'categories.show-more-button',
      buttonClass: '',
      filterList: [],
      activeFilterCount: 0,
      appliedInchAssortmentOnly: false,
      isCollapsedMobile: false,
      activeFilterShortName: null,
      opened: true
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.filterList = [...this.filters]
        this.setLocalizedFilters()
      }
    },
    productCount: {
      immediate: true,
      handler() {
        this.checkForDuplicateFilters()
        this.filterList = [...this.filters]
        this.setLocalizedFilters()
      }
    },
    showInchValues: {
      immediate: true,
      handler() {
        this.setLocalizedFilters()
      }
    }
  },
  computed: {
    currentFilters() {
      return this.filterList
    },
    showInchToggle() {
      return this.$globalization.getRegion()?.toLowerCase() === REGION_KEYS.NA?.toLowerCase()
    },
    filterOpened() {
      return this.opened
    },
    labelContainerRenderer() {
      // Access reactive deps here so computed re-evaluates when they change
      const show = !!(this.currentFilters.filter(f => f.isFilteredBy).length || this.appliedInchAssortmentOnly) && this.showChips
      const isMobile = this.isMobile
      const currentFilters = this.currentFilters
      const showInchValues = this.showInchValues
      const $tv = this.$tv.bind(this)
      const resetFilters = this.resetFilters.bind(this)
      const resetAllFilters = this.resetAllFilters.bind(this)
      const updateActiveFilterCount = this.updateActiveFilterCount.bind(this)
      return {
        render() {
          return h(
            'div',
            {
              class: 'category-filter-container__label-container',
              style: {display: show ? '' : 'none'}
            },
            [
              isMobile ? h('h3', $tv('active', 'categories')) : null,
              h(Labels, {
                filters: currentFilters,
                localizedMeasure: showInchValues ? 'inch' : 'mm',
                onResetInput: resetFilters,
                onResetAllFilters: resetAllFilters,
                onActiveFilters: updateActiveFilterCount
              })
            ]
          )
        }
      }
    }
  },
  methods: {
    updateActiveFilterCount(val) {
      this.activeFilterCount = val
    },
    async toggleShowInchValues() {
      const userStore = useUserStore()
      userStore.setShowInchValues(!this.showInchValues)
      this.$emit('filterInchValues', this.showInchValues)
    },
    setLocalizedFilters() {
      this.filterList.forEach((filter) => {
        let shortName = this.$tv(
          filter.shortName,
          'attributesShort',
          'shortNameNotAvailable'
        )
        let longName = this.$tv(filter.shortName, 'attributes')
        let label = longName
        let title = longName

        if (filter.displayName) {
          label = filter.displayName
          title = filter.displayName
        }

        filter.hasInfoIcon =
          filter.shortName?.toLowerCase() ===
          NON_ATTRIBUTE_FILTERS.BRAND.toLowerCase()

        if (shortName !== 'shortNameNotAvailable' && shortName !== label) {
          label += ' (' + shortName + ')'
          title += ' (' + shortName + ')'
        }
        let localizedUnitOfMeasure = filter.unitOfMeasure
        if (filter.unitOfMeasure) {
          const lowerUnitOfMeasure = filter.unitOfMeasure.toLowerCase()
          const unitOfMeasureKey = this.showInchValues && lowerUnitOfMeasure === 'mm' ? 'inch' : lowerUnitOfMeasure
          const displayUnitOfMeasure = this.$tv(unitOfMeasureKey, 'unitsOfMeasure', unitOfMeasureKey)
          localizedUnitOfMeasure = unitOfMeasureKey
          label += ' [' + displayUnitOfMeasure + ']'
          title = this.$te('product.attributeFullName')
            ? this.$tv(
              {
                messageKey: 'attributeFullName',
                messageValues: {
                  fullName: title,
                  unitOfMeasure: displayUnitOfMeasure
                }
              },
              'product'
            )
            : title + ' [' + displayUnitOfMeasure + ']'
        }

        if (filter.shortName === NON_ATTRIBUTE_FILTERS.BRAND) {
          filter.translateLabel = true
          filter.customTranslatePrefix = 'brands'
        }

        title = process.client ? sanitizeHtml(title, window.document) : title
        filter.label = label
        filter.localizedUnitOfMeasure = localizedUnitOfMeasure
        filter.title = title
        if ((filter.displayName || filter.displayNameShort) && filter.type === VALUE_TYPES.BOOLEAN) {
          filter.label = filter.displayNameShort && filter.displayNameShort !== '' ? filter.displayNameShort : filter.displayName
        }
      })
    },
    setActiveFilter(shortName) {
      if (shortName !== 'shore_hardness_primary') {
        this.activeFilterShortName = shortName
        this.$emit('update:activeFilter', shortName)
      }
    },
    clearActiveFilter() {
      this.activeFilterShortName = null
      this.$emit('update:activeFilter', null)
    },
    applyFilterHandler() {
      this.activeFilterShortName = null
      this.$emit('update:activeFilter', null)
      this.$emit('applyFilters', this.currentFilters)
    },
    displayAllFilter() {
      this.showAllFilters = !this.showAllFilters
      this.buttonText = this.showAllFilters
        ? 'categories.show-less-button'
        : 'categories.show-more-button'
      this.buttonClass = this.showAllFilters ? 'open-icon' : ''
    },
    emitter(emitText, val) {
      this.$emit(emitText, val)
    },
    resetFilters(labels) {
      if (labels) {
        let filter = this.filterList.filter((val) => !labels.includes(val))
        const index = this.filterList.findIndex(
          (el) => el.shortName === filter[0].shortName
        )
        if (index !== -1) {
          this.filterList[index].values = setFilterValues(
            this.filterList[index].type
          )
          this.filterList[index].isActive = false
          this.filterList[index].isFilteredBy = false
          this.filterList[index].activeValues = null
        }
      } else {
        this.filterList.forEach((filter) => {
          if (!filter.isDisabled) {
            filter.values = setFilterValues(filter.type)
            filter.isActive = false
            filter.isFilteredBy = false
            filter.activeValues = null
          }
        })
      }
      this.$emit('applyFilters', this.filterList)
    },
    resetAllFilters() {
      this.$emit('resetAllFilters')
    },
    checkForDuplicateFilters() {
      const result = detectDuplicateFilters(this.filters)

      if (result.hasDuplicates) {
        logDuplicatesToSentry(result.duplicates, {
          location: 'CategoryFilter',
          route: this.$route?.path,
          totalFilters: this.filters.length,
          uniqueFilters: result.uniqueFilters.length
        })
      }

      return result.duplicates
    },
    getFilterValuesFromFacets(filter) {
      let prop = ATTRIBUTE_IDENTIFIER_NEW + filter.shortName
      let translatable = true
      if (isNoAttributeFilter(filter.shortName, true)) {
        prop = filter.indexPath ? filter.indexPath : mapProductAttributeNames(filter.shortName)
        prop = mapProductAttributeNames(prop)
      } else {
        prop = filter.indexPath ? mapProductAttributeNames(filter.indexPath) : ATTRIBUTE_IDENTIFIER_NEW + filter.shortName
        if (prop.startsWith('characteristics/')) {
          prop = ATTRIBUTE_IDENTIFIER_NEW + prop.substring('characteristics/'.length)
        }
        filter.customTranslatePrefix =
          'attributes.' + filter.shortName + '-values'
        translatable = this.i18n.messages.value[this.i18n.locale.value]?.attributes &&
          typeof this.i18n.messages.value[this.i18n.locale.value]?.attributes[
            filter?.shortName + '-values'
          ] === 'object'
      }

      let facets = this.facets[prop] ?? []

      // CCRS FIX: If filter has values but no facets, add the values as facets (only for CCRS)
      if (this.showResetOnCcrs && facets.length === 0 && filter.values) {
        if (Array.isArray(filter.values) && filter.values.length > 0) {
          // For multiselect filters (STRING type)
          facets = filter.values.map(v => ({
            value: v.value || v,
            count: 1,
            label: v.label || v.value || v
          }))
        } else if (typeof filter.values === 'object' && filter.values.value !== undefined && filter.values.value !== null) {
          // For min/max number filters
          facets = [{
            value: filter.values.value,
            count: 1,
            label: String(filter.values.value)
          }]
        }
      }

      if (facets && translatable) {
        facets.forEach((facet) => {
          const translationPrefix = filter.customTranslatePrefix
            ? filter.customTranslatePrefix
            : DEFAULT_VALUES.FILTER_TRANSLATE_PREFIX
          facet.label = this.$tv(facet.value, translationPrefix)
        })
      }
      return facets
    },
    isTypeMultiString(type) {
      return type === VALUE_TYPES.MULTI_STRING
    },
    isTypeMultiDouble(type) {
      return type === VALUE_TYPES.MULTI_DOUBLE
    },
    isTypeMultiInteger(type) {
      return type === VALUE_TYPES.MULTI_INTEGER
    },
    isTypeString(type) {
      return type === VALUE_TYPES.STRING
    },
    isTypeBool(type) {
      return type === VALUE_TYPES.BOOLEAN
    },
    isTypeDropdown(type) {
      return type === VALUE_TYPES.DROPDOWN
    },
    isTypeNumber(type) {
      return type === VALUE_TYPES.INTEGER || type === VALUE_TYPES.FLOAT
    },
    isTypeMinMaxNumber(type) {
      return type === VALUE_TYPES.MIN_FLOAT || type === VALUE_TYPES.MAX_FLOAT
    },
    isFilterDisabled(filter) {
      const facets = this.getFilterValuesFromFacets(filter)
      if (facets.length === 1 && !filter.activeValues && !filter.isDisabled) {
        return facets[0].count === this.productCount
      }
      return filter.isDisabled ? true : facets.length === 0
    },
    categoryChange(event, filter) {
      if (event && Object.keys(event).length > 0 && !Array.isArray(event)) {
        filter.values = event
        this.emitter('categoryChange', event)
      }
    },
    toggleFilter() {
      this.opened = !this.opened
    }
  }
}
</script>

<style lang="scss">
.category-filter-container {
  position: relative;
  padding: 0 $default-margin-padding-2x;
  background-color: $color__content--background__secondary;

  &--categories-page {
    .category-filter-header-wrapper {
      @include breakpoint-down($md) {
        padding: $default-margin-padding-width;

        &.on-mobile {
          .category-filter-subheader {
            display: none;
          }
        }
      }
    }

    .category-filter-container__filters {
      &__collapsible-header {
        order: 1;
        padding: $default-margin-padding-width $default-margin-padding-width 0;
        cursor: pointer;

        .header-clickable {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-bottom: .75rem;

          &.opened {
            .expand-more-icon {
              transform: rotate(180deg);
            }
          }

          h3 {
            order: initial;
          }

          .icon.icon--svg {
            font-size: 1.5rem;
            color: $color__fst__primary;
            transition: transform .3s ease-in-out;
          }
        }
      }

      &--closed {
        row-gap: .25rem;
      }

      &__wrapper {
        @include breakpoint-down($md) {
          visibility: hidden;
          opacity: 0;
          transition: opacity .3s ease-in-out, max-height .2s ease-out, visibility .2s linear;
          max-height: 0;

          &--opened {
            visibility: visible;
            opacity: 1;
            max-height: 100%;
          }
        }

         &__content {
          .coreFilter {
            @include breakpoint-down($md) {
              flex-basis: calc(100% - 2rem);
            }
          }

          &.show-core-filters-only {
            @include breakpoint-down($md) {
              .noCoreFilter {
                display: none;
              }
            }
          }

          @include breakpoint-down($md) {
            margin: 0;
            width: 100%;
            padding: 0 0 0 1rem;
            row-gap: 1.25rem;

            > *:empty {
              display: none;
            }

            &__filter .filter-item-wrapper {
              margin: 0;
              width: 100%;
            }
          }
        }
      }

      &.no-image-content {
        .category-filter-container__filters__wrapper {
          &__content {
            @include breakpoint-down($md) {
              padding: 0 0 $default-margin-padding-width $default-margin-padding-width;
              row-gap: $default-margin-padding-width * 1.25;
            }
          }
        }
      }

      @include breakpoint-down($md) {
        margin: 0 $default-margin-padding-width;
        box-shadow: 0 0 .5rem 0 $color--card__shadow;
        width: calc(100% - 2rem);
        padding-bottom: $default-margin-padding-width;

        &__wrapper {
          flex: 0 0 calc(100%);
          max-width: calc(100%);
        }
      }

      .category-filter-container__button__wrapper {
        @include breakpoint-down($md) {
          flex-direction: column;
          padding: 0 $default-margin-padding-width;
          margin-top: 1.875rem;
        }
      }
    }
  }

  .category-filter-header-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &--ccrs {
      .expand-more-icon--mobile {
        display: none;
      }

      @include breakpoint-down($md) {
        display: flex;
        flex-direction: column !important;
        align-items: flex-start !important;

        .category-filter-header-clickable {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          &.clickable {
            cursor: pointer;
          }

          .expand-more-icon--mobile {
            font-size: 1.5rem;
            transition: transform 0.3s ease;
            color: $color__fst__primary;
            display: block;

            &.open-icon {
              transform: rotate(180deg);
            }
          }
        }

        h2 {
          display: none;
        }

        h3 {
          order: initial;
        }

        .category-filter__unit-switch {
          position: static !important;
          display: block !important;
          margin-top: 0 !important;
          margin-left: 0 !important;
        }
      }
    }
  }

  .category-filter-header {
    @include breakpoint-down($md) {
      margin-top: 0;
    }
  }

  &__unit-switch {
    position: absolute;
    right: 0;
    top: 0;

    @include breakpoint-down($md) {
      display: none;
    }
  }

  h2, h3 {
    margin: 0;
    padding: .5rem 0;

    @include breakpoint-down($md) {
      order: 1;
    }
  }

  &__filters {
    $gap: 1.25rem;

    display: flex;
    gap: $gap;
    width: 100%;
    padding-bottom: $default-margin-padding-1_5x;

    &__wrapper {
      display: flex;
      flex-flow: column;
      max-width: calc(67% - 0.625rem);
      width: 100%;

      &__content {
        display: flex;
        flex-wrap: wrap;
        margin-left: -$gap;
        margin-top: -$gap;

        .coreFilter {
          order: 1;
        }

        .noCoreFilter {
          order: 2;

          @include breakpoint-down($md) {
            width: calc(100% - 2rem);
          }
        }

        &__toggleSwitch {
          display: flex;
          align-items: flex-end;

          .filter-item-wrapper {
            display: block;
            min-height: 2.375rem;

            &:deep(label) {
              overflow: inherit;
            }

            .toggle-switch-container .k-switch  {
              margin: 0 .5rem 0 0;
            }
          }

          .switch {
            margin: .325rem 0;
          }
        }

        &__filter,
        &__toggleSwitch {
          .filter-item-wrapper {
            width: 11.5625rem;
            margin: $gap 0 0 $gap;
          }

          .toggleSwitch {
            padding: 1.5rem 0 0;
          }
        }
      }
    }

    &__content__image {
      display: flex;
      flex: 0 0 calc(33% - 0.625rem);
      width: 100%;
      max-width: 24.75rem;
      min-width: 20rem;

      @include breakpoint-down($md) {
        display: none;
        transition: all .2s ease-out;

        &--opened {
          display: flex;
        }
      }

      .installationsketch-container {
        width: 100%;

        .image-title {
          font-size: 0.875rem;
          line-height: 1.1375rem;
          font-weight: 300;
          height: 1.1875rem;
          margin-bottom: 0.375rem;

          @include breakpoint-down($md) {
            padding: $default-margin-padding-width $default-margin-padding-width 0;
          }
        }

        .image-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: $color__white;
          cursor: pointer;

          img {
            width: 100%;
            height: auto;
          }

          .image-text-link {
            padding-bottom: 0.5rem;
            font-size: 0.875rem;
            line-height: 1.1375rem;
            font-weight: $base-text-font-weight-semi-bold;
            color: $color__text__link;
            cursor: pointer;
          }
        }
      }
    }

    &.no-image-content {
      .category-filter-container__filters__wrapper {
        flex: 0 0 calc(100%);
        max-width: calc(100%);

        &__content {
          @include breakpoint-down($md) {
            margin: 0;
            width: 100%;
          }
        }
      }

      .category-filter-container__filters__content__image {
        display: none;
      }
    }

    @include breakpoint-down($lg - 1.5) {
      flex-direction: column-reverse;

      &__wrapper {
        flex: 0 0 calc(100% - 0.625rem);
        max-width: calc(100% - 0.625rem);
      }

      &__content__image {
        flex: 0 0 calc(100% - 0.625rem);
      }
    }
  }

  &__button__wrapper {
    margin-top: 2.5rem;
    display: flex;
    flex-flow: row wrap;
    gap: $default-margin-padding-width;

    .k-button {
      padding-right: .5rem;
      margin-bottom: $default-margin-padding-width;
    }

    .expand-more-icon {
      font-size: 1.5rem;
    }

    .button__secondary--showMore {
      .k-button-text {
        display: flex;
        justify-content: space-between;
        padding-right: .5rem;
      }

      @include breakpoint-down($md) {
        width: 100% !important;
        margin-bottom: .625rem;
        justify-content: center;
      }
    }

    @include breakpoint-down($md) {
      .k-button {
        margin-bottom: 0;
        width: 100%;
      }
    }

    &.no-core-filters {
      .button__secondary--showMore {
        display: none;
      }
    }

    @include breakpoint-down($md) {
      order: 4;
    }
  }

  &__label-container {
    @include breakpoint-down($md) {
      order: -1;
      background-color: $color__white;
      margin: 0;
      padding-inline: $default-margin-padding-width;
    }
  }

  @include breakpoint-down($md) {
    padding: 0;
    background-color: $color__content--background__primary;
    display: flex;
    flex-flow: column;
    flex-wrap: wrap;
    width: 100%;
  }

  .subline {
    margin-top: auto;
    margin-bottom: auto;
    margin-right: $default-margin-padding-width-small;
    font-weight: $base-text-font-weight-semi-bold;
  }
}
</style>
